module.exports = __webpack_public_path__ + "img/horror.13552b8e.svg";